import { useEffect, useRef, useState } from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const stats = [
  { value: 12400, suffix: '+', label: 'Active investors', prefix: '' },
  { value: 2.4, suffix: 'B+', label: 'Portfolio value tracked', prefix: '$' },
  { value: 18, suffix: 'M+', label: 'Annual dividends monitored', prefix: '$' },
  { value: 99.9, suffix: '%', label: 'Uptime SLA', prefix: '' },
]

function CountUp({ target, prefix, suffix, duration = 1500 }) {
  const [count, setCount] = useState(0)
  const ref = useRef(null)
  const hasAnimated = useRef(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true
          const startTime = performance.now()
          const animate = (currentTime) => {
            const elapsed = currentTime - startTime
            const progress = Math.min(elapsed / duration, 1)
            const eased = 1 - Math.pow(1 - progress, 3) // ease-out cubic
            setCount(eased * target)
            if (progress < 1) requestAnimationFrame(animate)
          }
          requestAnimationFrame(animate)
        }
      },
      { threshold: 0.5 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [target, duration])

  const display = target % 1 !== 0 ? count.toFixed(1) : Math.floor(count).toLocaleString()

  return (
    <span ref={ref}>
      {prefix}{display}{suffix}
    </span>
  )
}

export default function StatsBar() {
  const ref = useScrollAnimation({ stagger: 0.15 })

  return (
    <div className="bg-gradient-to-r from-[#F0FDF4] to-[#F8FAFC] border-t border-[#E2E8F0] border-b">
      <div ref={ref} className="content-max py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl lg:text-3xl font-mono font-semibold text-[#1B5E20] mb-1">
                <CountUp target={stat.value} prefix={stat.prefix} suffix={stat.suffix} />
              </p>
              <p className="text-xs text-[#94A3B8] uppercase tracking-widest">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
